// extracted by mini-css-extract-plugin
export default {"container":"ListStikers_container__yC1gP","form":"ListStikers_form__C+E8I","file":"ListStikers_file__IVMXW","grid":"ListStikers_grid__JbAKG scroll-menu"};